import React, { Component } from "react";
import { Col, Row } from "reactstrap";
import { InputAdornment } from "@mui/material";
import ClearIcon from "@mui/icons-material/Clear";
import IconButton from "@mui/material/IconButton";
import SearchIcon from "@mui/icons-material/Search";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import CloseIcon from "@material-ui/icons/Close";
import ErrorOutlineIcon from "@material-ui/icons/ErrorOutline";
import SaveIcon from "@material-ui/icons/Save";
import Tooltip from "@material-ui/core/Tooltip";
// import ForumIcon from "@mui/icons-material/Forum";
import DeleteIcon from "@mui/icons-material/Delete";
import { Menu } from "@mui/material";
import { withRouter } from "../../../withRouter";
import FetchServerData from "../../../provider/FetchServerData";
import store from "../../../redux/store";
import Utils from "../../../provider/Utils";
import MenuWithBreadScrum from "../menu/MenuWithBreadScrum";
import {
  MessageLogDeleteMultiple_Url,
  MessageLogDelete_Url,
  MessageLogList_Url,
  sendMessageToNotReplied_Url,
} from "../../../provider/ServiceUrl";
import DeleteButton from "../buttons/DeleteButton";
import ApplicationStateAction from "../../../redux/applicationState/ApplicationStateAction";
import PtsAlert from "../ptsAlert/PtsAlert";
import GroupLogListDialog from "../scheduledSend/GroupLogListDialog";
import ActivityLogListDialog from "../scheduledSend/ActivityLogListDialog";
import Pagination from "../pagination/Pagination";
import { BUSINESS_DOMAIN } from "../../../provider/Enums";
import _ from "lodash";
import AppUserDataAction from "../../../redux/appUserData/AppUserDataAction";
import SelectedDomainAction from "../../../redux/selectedDomain/SelectedDomainAction";
import MessagePrivewDialog from "./MessagePrivewDialog";
import PaginationRowAction from "../../../redux/paginationRow/PaginationRowAction";
class SendHistory extends Component {
  header = store.getState().header.header;
  sendHistoryState = store.getState().applicationState.sendHistoryState;
  paginationState = store.getState().paginations.sendHistoryState;
  businessDomain =
    store.getState().appUserData.appUserData.appuser?.businessDomain;
  businessDomainId = store.getState().businessDomain?.businessDomainId;
  sendHistoryStateDetails = {};
  paginationStateDetails = {};
  recipientInterval = null;
  refreshCount = 0;
  breadCrumb = [{ pageid: "", uiname: "Send History" }];
  title = "View and manage your send history";
  constructor(props) {
    super(props);
    if (this.sendHistoryState) {
      this.sendHistoryStateDetails = Object.getOwnPropertyNames(
        this.sendHistoryState
      );
    }
    if (this.paginationState) {
      this.paginationStateDetails = Object.getOwnPropertyNames(
        this.paginationState
      );
    }

    if (this.sendHistoryStateDetails.length > 0) {
      this.state = {
        pageNo: this.sendHistoryState.pageNo,
        pageSize: this.sendHistoryState.pageSize,
        messageId: this.sendHistoryState.messageId,
        selectedMessageLogList: new Set(),
        index: 0,
        messageContent: "",
        searchText: "",
        sendMessageLog: null,
        smsMessageLogList: [],
        getUpdatePermission: false,
        getDeletePermission: false,
        open: false,
        showToolbarBtn: false,
        isCtrlPressed: false,
        isShiftPressed: false,
        sendMessageOpen: false,
        deleteFromHistoryOpen: false,
        render: false,
        sortColumn: this.sendHistoryState?.sortColumn,
        isAscSort: this.sendHistoryState?.isAscSort,
        sortDirection: "asc",
      };
    } else {
      this.state = {
        messageContent: "",
        searchText: "",
        messageId: "",
        sendMessageLog: null,
        selectedMessageLogList: new Set(),
        index: 0,
        pageNo: 0,
        pageSize:
          this.paginationStateDetails?.length > 0
            ? this.paginationState?.pageSize
            : 100,
        smsMessageLogList: [],
        open: false,
        getUpdatePermission: false,
        getDeletePermission: false,
        showToolbarBtn: false,
        isCtrlPressed: false,
        isShiftPressed: false,
        sendMessageOpen: false,
        deleteFromHistoryOpen: false,
        render: false,
        sortColumn: this.paginationStateDetails?.length > 0
          ? this.paginationState?.sortColumn : null,
        isAscSort: this.paginationStateDetails?.length > 0
          ? this.paginationState?.isAscSort : false,
        sortDirection: "asc",
      };
    }
    this.getSendHistoryList(this.state.pageNo, this.state.pageSize, this.state.sortColumn, this.state.isAscSort);
    this.debouncedSearch = _.debounce(this.getSendHistoryList, 800);
  }

  componentDidMount() {
    window.addEventListener("keydown", this.handleKeyDown);
    window.addEventListener("keyup", this.handleKeyUp);
    this.isComponentMounted = true;
  }

  componentWillUnmount() {
    window.removeEventListener("keydown", this.handleKeyDown);
    window.removeEventListener("keyup", this.handleKeyUp);
    this.isComponentMounted = false;
    this.stopRecipientAutoRefresh();
  }

  handleKeyDown = (event) => {
    if (event.key === "Control") {
      this.setState({ isCtrlPressed: true });
    } else if (event.key === "Shift") {
      this.setState({ isShiftPressed: true });
    }
  };

  handleKeyUp = (event) => {
    if (event.key === "Control") {
      this.setState({ isCtrlPressed: false });
    } else if (event.key === "Shift") {
      this.setState({ isShiftPressed: false });
    }
  };

  onSearchChange(e) {
    this.setState({ searchText: e.target.value });
    this.debouncedSearch(0, this.state.pageSize);
  }

  getSendHistoryList(pageNo, pageSize, sortBy, isAscSort) {
    const postObject = {
      header: this.header,
      event: {
        id: this.businessDomainId,
      },
      page: {
        searchText: this.state.searchText,
        pageNo: pageNo,
        pageSize: pageSize,
        sortBy: sortBy,
        isAscSort: isAscSort,
      },
    };

    FetchServerData.callPostService(MessageLogList_Url, postObject).then(
      (output) => {
        if (output.status === "SUCCESS") {
          let smsMessageLogList = output.data.smsMessageLogList;
          let page = output.data.page;
          let smsCredits = output.data.smsCredits;
          let getPermission = Utils.getRolePermission(
            output.data?.privilegeList
          );
          let getUpdatePermission = getPermission[3];
          let getDeletePermission = getPermission[4];
          if (smsCredits !== null) {
            const { showCardexpiryMessage, ...smsCreditsWithoutFlag } = smsCredits;
            if (this.businessDomain === BUSINESS_DOMAIN.eventText) {
              store.dispatch(
                SelectedDomainAction.setEventCreditUsage(smsCreditsWithoutFlag)
              );
            } else {
              store.dispatch(
                AppUserDataAction.setUsage(smsCreditsWithoutFlag)
              );
            }
          }
          for (let i = 0; i < smsMessageLogList.length; i++) {
            smsMessageLogList[i].createdOn = this.businessDomain === BUSINESS_DOMAIN.eventText ? Utils.getUtcToEventTimezone(smsMessageLogList[i].createdOn) : Utils.getUtcToLocalDateTimeZone(
              smsMessageLogList[i].createdOn
            );
          }
          for (let i = 0; i < smsMessageLogList.length; i++) {
            smsMessageLogList[i].checked = false;
            this.setState({
              allCheckBoxSelected: false,
              showToolbarBtn: false,
            });
          }

          if (this.isComponentMounted && this.isAnyMessageSending(smsMessageLogList)) {
            this.startRecipientAutoRefresh();
          } else {
            this.stopRecipientAutoRefresh();
          }

          this.setState({
            render: true,
            sendMessageOpen: false,
            deleteFromHistoryOpen: false,
            smsMessageLogList: smsMessageLogList,
            pageNo: page.pageNo,
            showPerPage: page.pageSize,
            totalPages: page.totalPages,
            totalRecords: page.total,
            getUpdatePermission: getUpdatePermission,
            getDeletePermission: getDeletePermission,
          });
        } else {
        }
      }
    );
  }


  isAnyMessageSending = (list) => {
    return list?.some(
      (item) => item.status?.toLowerCase() === "sending"
    );
  };

  startRecipientAutoRefresh = () => {
    if (this.recipientInterval) return;
    this.recipientInterval = setInterval(() => {
      if (!this.isComponentMounted) return;

      this.getSendHistoryList(this.state.pageNo, this.state.pageSize);
    }, 12000);
  };

  stopRecipientAutoRefresh = () => {
    if (this.recipientInterval) {
      clearInterval(this.recipientInterval);
      this.recipientInterval = null;
    }
  };

  onPaginationChange(returnProp) {
    let counter = returnProp.counter;
    let pageNo = this.state.pageNo + counter;
    let pageSize = returnProp.showPerPage;
    const sendHistoryState = {
      pageSize: pageSize,
      sortColumn: this.state.sortColumn,
      isAscSort: this.state.isAscSort,
    };
    store.dispatch(
      PaginationRowAction.setSendHistoryPaginationState({ sendHistoryState })
    );
    let buttonIndex = returnProp.buttonIndex;
    let currentPageIndex =
      typeof counter !== "undefined" ? pageNo : buttonIndex;
    let resetPageNo = returnProp.resetPageNo;
    if (resetPageNo === true) {
      currentPageIndex = 0;
    }
    let dataRows = this.state.smsMessageLogList;
    for (let i = 0; i < dataRows.length; i++) {
      dataRows[i].checked = false;
      this.setState({
        allCheckBoxSelected: false,
        showToolbarBtn: false,
      });
    }

    this.getSendHistoryList(currentPageIndex, pageSize, this.state.sortColumn, this.state.isAscSort);

    this.setState({
      pageNo: currentPageIndex,
      pageSize: pageSize,
    });
  }

  rowItemSelected(rowData, e) {
    let selectedItems = this.state.smsMessageLogList;
    for (let i = 0; i < selectedItems.length; i++) {
      if (rowData.id === selectedItems[i].id) {
        if (rowData.tableData.checked) {
        } else {
        }
      }
    }
    this.setState({ smsMessageLogList: selectedItems });
  }

  onCheckBoxSelect(e, rowData, index) {
    const { isCtrlPressed, isShiftPressed, smsMessageLogList } = this.state;
    let selectedItems = [...smsMessageLogList]; // Create a copy to avoid mutating state

    if (isCtrlPressed || isShiftPressed) {
      // Find the first checked item
      let firstItemIndex = selectedItems.findIndex((item) => item.checked);
      if (firstItemIndex === -1) firstItemIndex = index; // Default to current index if none checked

      // Determine range to check
      let [start, end] = [firstItemIndex, index].sort((a, b) => a - b);
      for (let i = start; i <= end; i++) {
        selectedItems[i].checked = true;
      }
    } else if (isCtrlPressed) {
      selectedItems[index].checked = e.target.checked;
    } else {
      selectedItems.forEach((item) => {
        if (item.id === rowData.id) {
          item.checked = e.target.checked;
        }
      });
    }

    // Check if all checkboxes are selected
    const allChecked = selectedItems.every((item) => item.checked);

    // Check if at least one checkbox is selected
    const anyChecked = selectedItems.some((item) => item.checked);

    this.setState({
      smsMessageLogList: selectedItems,
      allCheckBoxSelected: allChecked,
      showToolbarBtn: anyChecked,
    });
  }

  onAllCheckBoxSelect(e) {
    let isChecked = e.target.checked;
    let dataRows = this.state.smsMessageLogList;
    for (let i = 0; i < dataRows.length; i++) {
      const row = dataRows[i];
      this.onCheckBoxSelect(e, row, i);
    }
    this.setState({
      allCheckBoxSelected: isChecked,
    });
  }

  toRecipientsDetailList(e, data) {
    let sendHistoryState = {
      messageId: data.id,
      pageNo: this.state.pageNo,
      pageSize: this.state.pageSize,
      sortColumn: this.state.sortColumn,
      isAscSort: this.state.isAscSort,
    };
    store.dispatch(
      ApplicationStateAction.setApplicationState({ sendHistoryState })
    );
    if (this.businessDomain === BUSINESS_DOMAIN.eventText) {
      this.props.navigate("/eventRecipientsList", {
        state: {
          pageId: "sendHistory",
          smsMessageLog: data,
        },
      });
    } else if (this.businessDomain === BUSINESS_DOMAIN.dpText) {
      this.props.navigate("/dptextRecipientsList", {
        state: {
          pageId: "sendHistory",
          smsMessageLog: data,
        },
      });
    } else {
      this.props.navigate("/recipientsList", {
        state: {
          pageId: "sendHistory",
          smsMessageLog: data,
        },
      });
    }
  }

  deleteMultipleMessageLogHistory(pageNo, pageSize) {
    let deleteMessageLogIds = [];
    for (let i = 0; i < this.state.smsMessageLogList.length; i++) {
      if (this.state.smsMessageLogList[i]?.checked === true) {
        deleteMessageLogIds.push(this.state.smsMessageLogList[i].id);
      }
    }
    const postObject = {
      header: this.header,
      messageLogIds: deleteMessageLogIds,
      page: {
        searchText: this.state.searchText,
        pageNo: pageNo,
        pageSize: pageSize,
      },
    };
    FetchServerData.callPostService(
      MessageLogDeleteMultiple_Url,
      postObject
    ).then((output) => {
      if (output.status === "SUCCESS") {
        PtsAlert.success(output.message);
        this.getSendHistoryList(this.state.pageNo, this.state.showPerPage, this.state.sortColumn, this.state.isAscSort);
        this.setState({
          deleteFromHistoryOpen: false,
        });
      }
    });
  }

  deleteMessageLogHistory(data) {
    const postObject = {
      header: this.header,
      messageLog: {
        id: data.id,
      },
    };
    FetchServerData.callPostService(MessageLogDelete_Url, postObject)
      .then((output) => {
        if (output.status === "SUCCESS") {
          PtsAlert.success(output.message);
          this.getSendHistoryList(this.state.pageNo, this.state.showPerPage, this.state.sortColumn, this.state.isAscSort);
          this.setState({
            showToolbarBtn: false,
          });
        } else {
        }
      })
      .catch((error) => { });
  }

  toGroupLogList(data) {
    if (this.groupListDialogueRef && this.groupListDialogueRef.current) {
      this.groupListDialogueRef.current.showGroupLogList(data, "SendHistory");
    }
  }
  toActivityLogList(data) {
    if (this.ActiveListDialogueRef && this.ActiveListDialogueRef.current) {
      this.ActiveListDialogueRef.current.showActivityLogList(data);
    }
  }

  sendMessageToContactsNotReplied() {
    const postObject = {
      header: this.header,
      messageLog: {
        id: this.state.sendMessageLog?.id,
      },
    };
    FetchServerData.callPostService(sendMessageToNotReplied_Url, postObject)
      .then((output) => {
        if (output.status === "SUCCESS") {
          PtsAlert.success(output.message);
          this.getSendHistoryList(this.state.pageNo, this.state.pageSize, this.state.sortColumn, this.state.isAscSort);
          this.setState({
            sendMessageOpen: false,
          });
        } else {
        }
      })
      .catch((error) => { });
  }

  handleSendMessageOpen(rowData) {
    this.setState({
      sendMessageLog: rowData,
      sendMessageOpen: true,
    });
  }
  handleSendMessageClose() {
    this.setState({
      sendMessageOpen: false,
    });
  }
  showActionButton(rowData) {
    return (
      <>
        <div className="row d-flex">
          <div className="col-md-8 d-flex">
            {(rowData.groupCount > 0 ||
              rowData.activityCount > 0 ||
              rowData.isAllOptins === true ||
              rowData.isAllPending === true) ? (
              <Tooltip
                title="Groups Selected"
                classes={{ popper: "custom-tooltip" }}
                arrow
              >
                <a
                  href="#"
                  style={{ cursor: "pointer", marginTop: "2px" }}
                  onClick={this.toGroupLogList.bind(this, rowData)}
                >
                  <i
                    className="menu-icon tf-icons fas fa-users"
                    style={{
                      color: "#6A7B8E",
                      fontSize: "19px",
                      padding: "3px",
                    }}
                  ></i>
                </a>
              </Tooltip>
            ) : (
              <span style={{ width: "31.75px" }}></span>
            )}

            {this.state.getDeletePermission && (
              <span style={{ cursor: "pointer" }}>
                <DeleteButton
                  pageId="sendHistory"
                  title={rowData.messageName}
                  domainObject={rowData.messageName}
                  onClick={this.deleteMessageLogHistory.bind(this, rowData)}
                />
              </span>
            )}

            {/* {rowData.activityCount > 0 ? (
              <Tooltip title="Activities">
                <a
                  href="#"
                  className="ms-2"
                  style={{ cursor: "pointer", marginTop: "2px" }}
                  onClick={this.toActivityLogList.bind(this, rowData)}
                >
                  <ForumIcon
                    style={{
                      color: "#6A7B8E",
                      fontSize: "28px",
                      padding: "3px",
                    }}
                  />
                </a>
              </Tooltip>
            ) : (
              <span style={{ marginLeft: "35px" }}></span>
            )} */}
            {/* {rowData.messageType === "Quick Text" ? (
              <Tooltip title="Resend this message to those that did not reply.">
                <a
                  href="#"
                  className="ms-2"
                  style={{ cursor: "pointer", marginTop: "2px" }}
                  onClick={this.handleSendMessageOpen.bind(this, rowData)}
                >
                  <i
                    className="fa fa-send-o ms-1"
                    style={{
                      color: "#6A7B8E",
                      fontSize: "18px",
                      padding: "3px",
                    }}
                  ></i>
                </a>
              </Tooltip>
            ) : (
              <span style={{ marginLeft: "35px" }}></span>
            )} */}
          </div>
        </div>
      </>
    );
  }

  handleQuickTextMessagePreviewClose = () => {
    this.setState({ open: false, anchorEl: null });
  };

  handleQuickTextMessagePreviewOpen = (e, rowData) => {
    this.setState({
      open: true,
      anchorEl: e.currentTarget,
      messageContent: rowData.messageContent,
    });
  };

  handleDeleteFromHistoryOpen() {
    this.setState({
      deleteFromHistoryOpen: true,
    });
  }
  handleDeleteFromHistoryClose() {
    this.setState({
      deleteFromHistoryOpen: false,
    });
  }
  handleAccountDropdownOpen = (e, rowData) => {
    let anchorEl = e.currentTarget;
    if (
      this.messagePreviewDialogueRef &&
      this.messagePreviewDialogueRef.current
    ) {
      this.messagePreviewDialogueRef.current.showMessagePreview(
        anchorEl,
        rowData
      );
    }
  };

  handleRowClick = (e, rowData) => {
    // Skip if clicking on action buttons
    if (e.target.closest(".action-button")) return;

    if (
      rowData.messageType === "Quick Text" ||
      rowData.messageType === "Quick text"
    ) {
      this.handleQuickTextMessagePreviewOpen(e, rowData);
    } else {
      this.handleAccountDropdownOpen(e, rowData);
    }
  };

  // handleSort(column) {
  //   const { sortColumn, sortDirection, smsMessageLogList } = this.state;
  //   let newDirection = "asc";

  //   if (sortColumn === column && sortDirection === "asc") {
  //     newDirection = "desc";
  //   }

  //   this.setState({
  //     smsMessageLogList: Utils.sortList(
  //       smsMessageLogList,
  //       column,
  //       newDirection
  //     ),
  //     sortColumn: column,
  //     sortDirection: newDirection,
  //   });
  // }

  handleSort(column) {
    const { sortColumn, sortDirection, pageNo, pageSize } = this.state;
    const newDirection =
      sortColumn === column && sortDirection === "asc" ? "desc" : "asc";

    const isAscSort = newDirection === "asc";
    const sendHistoryState = {
      pageSize: pageSize,
      sortColumn: column,
      isAscSort: isAscSort,
    };
    store.dispatch(
      PaginationRowAction.setSendHistoryPaginationState({ sendHistoryState })
    );
    this.setState(
      {
        sortColumn: column,
        sortDirection: newDirection,
        isAscSort: isAscSort,
      },
      () => {
        this.getSendHistoryList(pageNo, pageSize, column, isAscSort);
      }
    );
  }

  render() {
    this.groupListDialogueRef = React.createRef();
    this.ActiveListDialogueRef = React.createRef();
    this.messagePreviewDialogueRef = React.createRef();
    const checkedCount = this.state.smsMessageLogList?.filter(
      (item) => item?.checked === true
    )?.length;

    if (this.state.render === false) {
      return <div />;
    }
    return (
      <>
        <MenuWithBreadScrum
          breadCrumb={this.breadCrumb}
          history={this.props.history}
          name={this.title}
          isSearchText={this.state.searchText !== ""}
        />
        <GroupLogListDialog
          ref={this.groupListDialogueRef}
          style={{ float: "right" }}
        />
        <ActivityLogListDialog
          ref={this.ActiveListDialogueRef}
          style={{ float: "right" }}
        />
        <MessagePrivewDialog
          ref={this.messagePreviewDialogueRef}
          style={{ float: "right" }}
        />
        <div className="row">
          <div className="col">
            <div className="col md-12">
              <div className="card rounded-0">
                <div
                  className="row justify-content-between"
                  style={{ padding: "0.6em 1.2rem" }}
                >
                  <div className="d-flex col-12 col-lg-5 col-xl-5">
                    <div className="col-12 text-start totalResults align-self-center">
                      <span>Messages Sent: {Utils.formatWithCommas(this.state.totalRecords)}</span>
                    </div>
                  </div>
                  <div className="d-flex col-12 col-lg-7 col-xl-7 justify-content-end">
                    {this.state.showToolbarBtn && (
                      <span className="me-4">
                        <Button
                          type="button"
                          onClick={this.handleDeleteFromHistoryOpen.bind(this)}
                          style={{
                            height: "25px",
                            padding: "2px 10px",
                            color: "red",
                            border: "solid 2px red",
                            textTransform: "capitalize",
                          }}
                          className="btn btn-default "
                          startIcon={
                            <DeleteIcon style={{ fontSize: "16px" }} />
                          }
                        >
                          Delete Selected
                        </Button>
                      </span>
                    )}
                    <TextField
                      id="standard-search"
                      placeholder="Search"
                      type="text"
                      variant="standard"
                      value={this.state.searchText}
                      onChange={this.onSearchChange.bind(this)}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <IconButton
                              onClick={this.getSendHistoryList.bind(
                                this,
                                0,
                                this.state.pageSize
                              )}
                            >
                              <SearchIcon />
                            </IconButton>
                          </InputAdornment>
                        ),
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton
                              onClick={() => {
                                this.setState({ searchText: "" }, () => {
                                  this.getSendHistoryList(
                                    0,
                                    this.state.pageSize
                                  );
                                });
                              }}
                              disabled={!this.state.searchText}
                            >
                              <ClearIcon
                                style={{
                                  opacity: this.state.searchText ? 1 : 0.4,
                                  fontSize: "1.25rem",
                                  color: "353538",
                                }}
                              />
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                    />
                  </div>
                </div>
                <div className="table-responsive paginationTable">
                  <table className="table text-start table-hover">
                    <thead className="paginationTableThead">
                      <tr>
                        <th
                          className="col fw-bold"
                          style={{ alignContent: "center" }}
                        >
                          <div className="col-sm-12">
                            <input
                              type="checkbox"
                              style={{
                                width: "15.5px",
                                height: "15.5px",
                                marginTop: "6px",
                              }}
                              checked={this.state.allCheckBoxSelected}
                              onChange={this.onAllCheckBoxSelect.bind(this)}
                            />
                          </div>
                        </th>
                        <th className="col fw-bold cursor-pointer" onClick={() => this.handleSort("hashColor")}>
                          {this.state.sortColumn === "hashColor" &&
                            (this.state.sortDirection === "asc" ? (
                              <i
                                class="fa fa-long-arrow-up ps-1"
                                aria-hidden="true"
                              ></i>
                            ) : (
                              <i class="fa-solid fa-arrow-down-long ps-1"></i>
                            ))}
                        </th>
                        <th
                          className="cursor-pointer"
                          scope="col fw-bold"
                          onClick={() => this.handleSort("messageName")}
                        >
                          Message
                          {this.state.sortColumn === "messageName" &&
                            (this.state.sortDirection === "asc" ? (
                              <i
                                class="fa fa-long-arrow-up ps-1"
                                aria-hidden="true"
                              ></i>
                            ) : (
                              <i class="fa-solid fa-arrow-down-long ps-1"></i>
                            ))}
                        </th>
                        <th
                          className="col fw-bold cursor-pointer"
                          onClick={() => this.handleSort("messageType")}
                        >
                          Message Type
                          {this.state.sortColumn === "messageType" &&
                            (this.state.sortDirection === "asc" ? (
                              <i
                                class="fa fa-long-arrow-up ps-1"
                                aria-hidden="true"
                              ></i>
                            ) : (
                              <i class="fa-solid fa-arrow-down-long ps-1"></i>
                            ))}
                        </th>
                        <th
                          className="col fw-bold cursor-pointer"
                          onClick={() => this.handleSort("createdBy")}
                        >
                          Sent By
                          {this.state.sortColumn === "createdBy" &&
                            (this.state.sortDirection === "asc" ? (
                              <i
                                class="fa fa-long-arrow-up ps-1"
                                aria-hidden="true"
                              ></i>
                            ) : (
                              <i class="fa-solid fa-arrow-down-long ps-1"></i>
                            ))}
                        </th>
                        <th
                          className="col fw-bold cursor-pointer"
                          onClick={() => this.handleSort("createdOn")}
                        >
                          Send Date/Time
                          {this.state.sortColumn === "createdOn" &&
                            (this.state.sortDirection === "asc" ? (
                              <i
                                class="fa fa-long-arrow-up ps-1"
                                aria-hidden="true"
                              ></i>
                            ) : (
                              <i class="fa-solid fa-arrow-down-long ps-1"></i>
                            ))}
                        </th>
                        <th className="col fw-bold cursor-pointer" onClick={() => this.handleSort("contactCount")}>Contacts
                          {this.state.sortColumn === "contactCount" &&
                            (this.state.sortDirection === "asc" ? (
                              <i
                                class="fa fa-long-arrow-up ps-1"
                                aria-hidden="true"
                              ></i>
                            ) : (
                              <i class="fa-solid fa-arrow-down-long ps-1"></i>
                            ))}
                        </th>
                        {/* <th className="col fw-bold">Status</th> */}
                        <th className="col fw-bold">Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {this.state.smsMessageLogList?.map((rowData, index) => (
                        <tr
                          key={index}
                          // onClick={(e) => this.handleRowClick(e, rowData)}
                          style={{
                            backgroundColor:
                              rowData.id === this.state.messageId
                                ? "#e6effc"
                                : "",
                          }}
                        >
                          <td
                            className="action-button"
                            style={{ alignContent: "center", width: "25px" }}
                          >
                            <input
                              type="checkbox"
                              style={{
                                width: "15px",
                                height: "15px",
                                marginTop: "6px",
                              }}
                              checked={
                                rowData.checked ||
                                this.state.allCheckBoxSelected
                              }
                              onChange={(e) =>
                                this.onCheckBoxSelect(e, rowData, index)
                              }
                            />
                          </td>
                          <td
                            style={{ width: "40px" }}
                            onClick={(e) => e.stopPropagation()}
                          >
                            <span
                              style={{
                                backgroundColor: rowData.hashColor,
                                width: 20,
                                height: 20,
                                borderRadius: 3,
                                display: "inline-block",
                                marginTop: "6px",
                                // border: "1px solid #ccc",
                              }}
                            />
                          </td>
                          <td
                            style={{ width: "280px" }}
                            onClick={(e) =>
                              rowData.messageType === "Quick Text" ||
                                rowData.messageType === "Quick text"
                                ? this.handleQuickTextMessagePreviewOpen(
                                  e,
                                  rowData
                                )
                                : this.handleAccountDropdownOpen(e, rowData)
                            }
                          >
                            <span className="anchortag action-text">
                              {Utils.truncateString(rowData.messageName, 30)}
                              &nbsp;
                              {rowData.isMms ? "(MMS)" : ""}
                            </span>
                          </td>
                          <td
                            style={{ width: "220px" }}
                          >
                            {rowData.messageType}
                          </td>
                          <td
                            style={{ width: "220px" }}
                          >
                            {rowData.createdBy}
                          </td>
                          <td
                            style={{ width: "280px" }}
                          >
                            {rowData.createdOn}
                          </td>
                          <td
                            className="action-button"
                            style={{ width: "180px" }}
                          >
                            <span
                              className="anchortag"
                              onClick={(e) =>
                                this.toRecipientsDetailList(e, rowData)
                              }
                            >
                              {`${rowData.contactCount} Numbers`} &nbsp;
                              {rowData.status === "Sending" &&
                                <Tooltip title="Send in progress" classes={{ popper: "custom-tooltip" }}
                                  arrow >
                                  <svg width="10" height="30" viewBox="0 0 10 30">
                                    <rect x="2" y="20" width="6" height="8" rx="3" fill="#22c55e">
                                      <animate
                                        id="grow"
                                        attributeName="height"
                                        values="8;26;8"
                                        dur="1.2s"
                                        repeatCount="indefinite"
                                        calcMode="spline"
                                        keySplines="0.4 0 0.6 1;0.4 0 0.6 1"
                                      />
                                      <animate
                                        attributeName="y"
                                        values="20;2;20"
                                        dur="1.2s"
                                        repeatCount="indefinite"
                                        begin="grow.begin"
                                        calcMode="spline"
                                        keySplines="0.4 0 0.6 1;0.4 0 0.6 1"
                                      />
                                    </rect>
                                  </svg>
                                </Tooltip>
                              }
                            </span>
                          </td>
                          {/* <td
                            style={{ width: "160px" }}
                          >{`${rowData.status} (${rowData.totalMessages})`}</td> */}

                          <td
                            className="action-button"
                            style={{ width: "160px" }}
                            key={rowData.id}
                          >
                            {this.showActionButton(rowData)}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
                {this.state.totalRecords === 0 && (
                  <div
                    className="row text-center"
                    style={{ padding: "6px 20px" }}
                  >
                    <h5 className="dataNotAvailable">No data found.</h5>
                  </div>
                )}
                {this.state.totalRecords > 10 && (
                  <div className="row justify-content-between pagination p-1">
                    <div className="d-flex col-12 col-lg-4 col-xl-4">
                      <div className="pageSize col-12 text-start">
                        {/* Page {this.state.pageNo + 1} of {this.state.totalPages} */}
                        Messages Sent: {Utils.formatWithCommas(this.state.totalRecords)}
                      </div>
                    </div>
                    <div className="d-flex col-12 col-lg-8 col-xl-8">
                      <div className="col-12 text-end">
                        <Pagination
                          showPerPage={this.state.showPerPage}
                          pageNo={this.state.pageNo}
                          onPaginationChange={this.onPaginationChange.bind(
                            this
                          )}
                          total={this.state.totalRecords}
                        />
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
        {this.state.smsMessageLogList.length > 10 &&
          <div className="row mt-3 mb-3">
            <div className="col-sm-12 text-center">
              {this.state.showToolbarBtn && (
                <span className="me-4">
                  <Button
                    type="button"
                    onClick={this.handleDeleteFromHistoryOpen.bind(this)}
                    style={{
                      height: "25px",
                      padding: "2px 10px",
                      color: "red",
                      border: "solid 2px red",
                      textTransform: "capitalize",
                    }}
                    className="btn btn-default "
                    startIcon={
                      <DeleteIcon style={{ fontSize: "16px" }} />
                    }
                  >
                    Delete Selected
                  </Button>
                </span>
              )}
            </div>
          </div>
        }
        <Dialog
          open={this.state.sendMessageOpen}
          onClose={this.handleSendMessageClose.bind(this)}
          style={{ padding: "1em" }}
        >
          <DialogContent>
            <Row style={{ marginRight: "auto", marginLeft: "auto" }}>
              <Col md={12} style={{ textAlign: "center" }}>
                <ErrorOutlineIcon
                  style={{
                    border: "2px solid #fff",
                    borderRadius: "25%",
                    background: "#066f72 !important",
                    color: "red",
                    fontSize: "50px",
                  }}
                />
              </Col>
            </Row>
            <span style={{ textAlign: "center" }}>
              <h2 style={{ fontSize: "20px" }}>
                Resend this message to those that did not reply.
              </h2>
            </span>
          </DialogContent>
          <DialogActions
            style={{
              // marginTop: "1em",
              padding: "2em",
              marginLeft: "auto",
              marginRight: "auto",
            }}
          >
            <Button
              variant="contained"
              size="large"
              style={{
                background: "#37517e",
                color: "#fff",
                marginRight: "1rem",
                padding: "2px 10px",
                textTransform: "capitalize",
              }}
              startIcon={<SaveIcon />}
              onClick={this.sendMessageToContactsNotReplied.bind(this)}
            >
              Confirm
            </Button>
            <Button
              variant="contained"
              size="large"
              style={{
                background: "#717373",
                color: "#fff",
                marginRight: "1rem",
                padding: "2px 10px",
                textTransform: "capitalize",
              }}
              startIcon={<CloseIcon />}
              onClick={this.handleSendMessageClose.bind(this)}
            >
              Cancel
            </Button>
          </DialogActions>
        </Dialog>
        <Dialog
          open={this.state.deleteFromHistoryOpen}
          onClose={this.handleDeleteFromHistoryClose.bind(this)}
          style={{ padding: "1em" }}
        >
          <DialogContent>
            <span style={{ textAlign: "center" }}>
              <p className="m-0" style={{ fontSize: "16px" }}>
                {`The selected send histories (${checkedCount} items) will be deleted.`}
              </p>
            </span>
          </DialogContent>
          <DialogActions
            style={{
              padding: "1em",
              marginLeft: "auto",
              marginRight: "auto",
            }}
          >
            <Button
              variant="contained"
              type="button"
              size="large"
              style={{
                background: "#37517e",
                color: "#fff",
                marginRight: "1rem",
                padding: "2px 10px",
                textTransform: "capitalize",
              }}
              startIcon={<SaveIcon />}
              onClick={this.deleteMultipleMessageLogHistory.bind(
                this,
                this.state.pageNo,
                this.state.showPerPage
              )}
            >
              Confirm
            </Button>
            <Button
              variant="contained"
              size="large"
              type="button"
              style={{
                background: "#717373",
                color: "#fff",
                marginRight: "1rem",
                padding: "2px 10px",
                textTransform: "capitalize",
              }}
              startIcon={<CloseIcon />}
              onClick={this.handleDeleteFromHistoryClose.bind(this)}
            >
              Cancel
            </Button>
          </DialogActions>
        </Dialog>
        <Menu
          anchorEl={this.state.anchorEl}
          id="dropdown-menu1"
          className="filterDropdownMenu"
          open={this.state.open}
          onClose={this.handleQuickTextMessagePreviewClose}
          PaperProps={{
            elevation: 0,
            sx: {
              overflow: "visible",
              filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
              mt: 1.5,
              "& .MuiAvatar-root": {
                width: 32,
                height: 32,
                ml: -0.5,
                mr: 1,
              },
              "&:before": {
                content: '""',
                display: "block",
                position: "absolute",
                top: 0,
                left: 20,
                width: 10,
                height: 10,
                bgcolor: "background.paper",
                transform: "translateY(-50%) rotate(45deg)",
                zIndex: 0,
              },
            },
          }}
          transformOrigin={{ horizontal: "left", vertical: "top" }}
          anchorOrigin={{ horizontal: "left", vertical: "bottom" }}
        >
          <span className="closeIcon">
            <IconButton
              aria-label="close"
              onClick={this.handleQuickTextMessagePreviewClose.bind(this)}
              style={{
                position: "absolute",
                right: 8,
                top: 4,
                color: (theme) => theme.palette.grey[500],
              }}
            >
              <CloseIcon style={{ color: "#000", fontWeight: "600" }} />
            </IconButton>
          </span>
          <div
            style={{
              cursor: "pointer",
              width: "400px",
              height: "100%",
              fontSize: "14px",
            }}
          >
            <div className="p-4">
              <h6 className="fw-bold mb-2 ps-3">Message Preview</h6>
              <div className="col-md-12">
                <div className="chat-bubble">{this.state.messageContent}</div>
              </div>
            </div>
          </div>
        </Menu>
      </>
    );
  }
}

export default withRouter(SendHistory);
